import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const routes = [
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "/index",
    name: "home",
    component: () => import("@/views/index") //产业园区
  },
  {
    path: "/video",
    name: "video",
    component: () => import("@/views/video") //宣传视频
  },
  {
    path: "/science",
    name: "science",
    component: () => import("@/views/science") //科普导览
  },
  //   {
  //     path: "/schj",
  //     name: "schj",
  //     component: () => import("@/views/schj/schj") //市场环境
  //   },
  {
    path: "/granary",
    name: "granary",
    redirect: "/granary/index",
    component: () => import("@/views/granary"), //首页
    children: [
      {
        path: "/granary/index",
        name: "granaryIndex",
        component: () => import("@/views/granary/page/index")
      },
      //种植业
      {
        path: "/granary/zzy",
        name: "zzy",
        component: () => import("@/views/zzy/page/index")
      },
      {
        path: "/granary/xmy",
        name: "xmy",
        component: () => import("@/views/xmy/page/index")
      },
      {
        path: "/granary/yy",
        name: "yy",
        component: () => import("@/views/yy/page/index")
      },
      {
        path: "/granary/nc",
        name: "nc",
        component: () => import("@/views/nc/page/index")
      }
    ]
  },
  {
    path: "/jgqk",
    name: "jgqk"
    // component: () => import("@/views/jgqk") // 加工情况
  },
  {
    path: "/glzy",
    name: "glzy"
    // component: () => import("@/views/glzy") // 古荔资源
  },
  {
    path: "/lzys",
    name: "lzys",
    component: () => import("@/views/lzys") // 荔枝云商
  },
  {
    path: "/newIndex",
    name: "newIndex",
    component: () => import("@/views/newIndex") //新增index页面
  }
  // {
  //   path: "/orchard",
  //   name: "orchard",
  //   component: () => import("@/views/orchard") //智慧果园, 暂时无用到了
  // },
  //   {
  //     path: "/allmodule",
  //     name: "allmodule",
  //     component: () => import("@/views/allmodule") //组件集合页 to del, 已经独立出来了
  //   }
];

let router = null;
console.log("router:", process.env.NODE_ENV);
if (process.env.NODE_ENV === "prod1") {
  router = new VueRouter({
    // mode: "history",
    // base: process.env.VUE_APP_BASE_URL,
    routes
  });
} else {
  router = new VueRouter({
    mode: "history",
    base: process.env.VUE_APP_BASE_URL,
    routes
  });
}
export default router;
